module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-100.woff?7cd5ab5f4d9a41f59c34a4449936c8a3";